import widgetTemplate from './ac-widget.html';
import * as helpers from '../helpers';
import { bootstrapStyle } from '../styles';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { all } from '@awesome.me/kit-bd5fe14630/icons'

class AutoCompleteWidget extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        const style = document.createElement('style');
        style.textContent = bootstrapStyle;
        this.shadowRoot.appendChild(style);

        const template = document.createElement('section');
        template.classList.add('ha-widget');
        template.innerHTML = widgetTemplate;
        this.shadowRoot.appendChild(template);

        library.add(...all);
        dom.watch({
            autoReplaceSvgRoot: this.shadowRoot,
            observeMutationsRoot: this.shadowRoot
        });
    }

    connectedCallback() {
        this.baseUrl = helpers.getBaseUrl();
        this.baseApiUrl = helpers.getBaseApiUrl();
        this.target = this.getAttribute('target') || '';
        this.endpoint = this.getAttribute('endpoint') || 'Area';
        this.primaryColor = this.getAttribute('primary-color') || '#024267';
        this.fontFamily = this.getAttribute('font-family') || '"Helvetica Neue", Helvetica, Arial, sans-serif'
        this.fontUrl = this.getAttribute('font-url') || '';
        this.init();
    }

    init() {
        helpers.setColors(this);
        this.setupSearchInput();
    }

    setupSearchInput() {
        const searchInput = this.shadowRoot.getElementById('search-input');

        const placeholder = this.getAttribute('text-placeholder') || 'Search by City, Zip, Neighborhood...';
        searchInput.setAttribute('placeholder', placeholder);

        let timeoutId;
        let abortController = new AbortController();

        searchInput.addEventListener('input', (e) => {
            const inputValue = e.target.value.toLowerCase();
            helpers.closeAllLists(this);

            if (inputValue.length < 3) {
                return false;
            }

            const spinner = this.shadowRoot.querySelector('.searching');
            spinner.classList.remove('d-none');

            abortController.abort();
            abortController = new AbortController();

            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                if (this.endpoint === 'Address') {
                    this.getAddress(inputValue, abortController.signal, searchInput);
                }
                else {
                    this.getArea(inputValue, abortController.signal, searchInput);
                }
            }, 300);
        });
    }

    async getArea(text, signal, searchInput) {
        const endpoint = 'api/services/app/HomeSearch/GetSearchArea';
        const queryParams = { input: text };
        const url = `${this.baseApiUrl}${endpoint}?${helpers.serializeParams(queryParams)}`;

        try {
            const response = await fetch(url, { signal, headers: helpers.getHeaders() });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            const autocompleteItems = this.shadowRoot.getElementById('autocomplete-items');
            autocompleteItems.style.display = 'block';

            data.result.areas.forEach(suggestion => {
                const listItem = document.createElement('li');
                listItem.innerHTML = suggestion.label;
                listItem.addEventListener('click', () => {
                    searchInput.value = suggestion.label;
                    helpers.closeAllLists(this);
                    this.dispatchEvent(new CustomEvent('autocomplete:select', {
                        detail: {
                            value: suggestion.label,
                            target: this.target
                        },
                        bubbles: true,
                        composed: true  // allows crossing shadow DOM boundary
                    }));
                });
                autocompleteItems.appendChild(listItem);

                const spinner = this.shadowRoot.querySelector('.searching');
                spinner.classList.add('d-none');
            });
        } catch (error) {
            console.error('Fetch error:', error);
        }
    }

    async getAddress(text, signal, searchInput) {
        const endpoint = 'api/services/app/HomeSearch/GetAddressMatch';
        const queryParams = { input: text };
        const url = `${this.baseApiUrl}${endpoint}?${helpers.serializeParams(queryParams)}`;

        try {
            const response = await fetch(url, { signal });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            const autocompleteItems = this.shadowRoot.getElementById('autocomplete-items');
            autocompleteItems.style.display = 'block';

            data.result.matches.forEach(suggestion => {
                const listItem = document.createElement('li');
                listItem.innerHTML = suggestion.label;
                listItem.addEventListener('click', () => {
                    searchInput.value = suggestion.label;
                    helpers.closeAllLists(this);
                    this.dispatchEvent(new CustomEvent('autocomplete:select', {
                        detail: {
                            value: suggestion,
                            target: this.target
                        },
                        bubbles: true,
                        composed: true  // allows crossing shadow DOM boundary
                    }));
                });
                autocompleteItems.appendChild(listItem);

                const spinner = this.shadowRoot.querySelector('.searching');
                spinner.classList.add('d-none');
            });
        } catch (error) {
            console.error('Fetch error:', error);
        }
    }
}

if (!customElements.get('auto-complete-widget')) {
    customElements.define('auto-complete-widget', AutoCompleteWidget);
}

export default AutoCompleteWidget;